import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ButtonClickEvent,
  CoreService, DataService, DialogResult,
  DialogService, OptionSetService,
  SaveFormEvent,
  SpinnerService
} from "dspx-core";
import { BaseCardSetDetailComponent } from "../base-card-set-detail-component/base-card-set-detail.component";
import {
  NAV_TAB_NUMBERS,
  OPTION_SETS,
  OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS, PAGE_NUMBERS,
  POP_UP_CODES, QUESTION_CODES,
  SAVE_RESULT_STATUS, SECTION_CODES
} from "../../constants/app-data.constants";
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from "../../constants/api-endpoints.constants";
import { TEMPLATES, VERSIONS } from "../../constants/templates.constants";
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from "@angular/router";
import { AppDataService } from "../../services/app-data.service";
import { ErrorService } from "../../services/error.service";
import { ROUTE_CONSTANTS } from "../../constants/route.constants";
import { finalize, take } from "rxjs";
import { ResponseParserService } from "../../services/response-parser.service";
import { CareAllowancePersonSaveDataRequest } from "../../interfaces/care-allowance-person-save-data-request";

@Component({
  selector: 'app-care-allowance-person',
  templateUrl: './care-allowance-person.component.html',
  styleUrl: './care-allowance-person.component.scss'
})
export class CareAllowancePersonComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {
  fieldTypeReplacements = OVERVIEW_CARDSET_LAYOUT_FIELD_TYPE_REPLACEMENTS;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.careAllowancePerson;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';

  selectedContactType: string = '';
  isConcessionContact: boolean = false;
  showMultiContactType: boolean = false;
  showContactType: boolean = true;

  private routePrefix = '';
  private isEditing = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    protected optionSetService: OptionSetService,
    protected responseParserService: ResponseParserService,
    private coreService: CoreService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,
    private dataService: DataService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.conditionFunctions = {
      showPostalAddress: () => this.showPostalAddress(),
      showCommonFields: () => this.showCommonFields(),
      isVptasClient: () => this.isVptasClient(),
      isCareAllowanceClient: () => this.isCareAllowanceClient(),
      isCareAllowanceCarerOrConcessionApplicant: () => this.isCareAllowanceCarer() || this.isConcessionsApplicant(),
      isCareAllowanceCarerOrConcessionVptasApplicant: () => this.isCareAllowanceCarer() || this.isConcessionsApplicant()|| this.isVptasClient(),
      isCareAllowanceCarerOrVptasApplicant: () => this.isCareAllowanceCarer() || this.isVptasClient(),
      showContactType: () => this.showContactType || !this.isEditing,
      isCareAllowanceClientOrConcessionsApplicant: () => this.isCareAllowanceClient() || this.isConcessionsApplicant(),
      isCareAllowanceClientOrVptasApplicant: () => this.isCareAllowanceClient() || this.isVptasClient(),
      isConcessionOrVptasApplicant: () => this.isConcessionOrVptasApplicant() ,
      showMultiContactType: () => this.showMultiContactType,
      isEditing: () => this.isEditing,
      isMultiContactTypeReadOnly: () => this.isMultiContactTypeReadOnly(),
    };

    this.coreService.applicationFunctions = {
      checkEitherMobileOrOther: () => this.checkEitherMobileOrOtherPhone()
    };

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getCareAllowancePersonConfigAndResponse;
        this.isEditing = true;
      }
    });

  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any) {
    console.log(event);
    if (this.isEditing) {
      this.isConcessionContact = event.isConcessionContact;
      this.showMultiContactType = event.showMultiContactType;
      this.showContactType = event.showContactType;
    }
  }

  buttonClicked($event: ButtonClickEvent) {

  }

  filter(event: any): void {

  }

  private checkEitherMobileOrOtherPhone(): boolean {
   if(this.isVptasClient())
   {
    return !!(this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.mobilePhone || this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.otherPhone);
   }
   else  return true;
  }


  modelChanged($event: any) {
    this.selectedContactType = this.responseParserService.findQuestionModel(this.baseForm.model,
      NAV_TAB_NUMBERS.careAllowancePerson.personDetails,
      PAGE_NUMBERS.careAllowancePerson.personDetails,
      null,
      SECTION_CODES.careAllowancePerson.profile,
      null,
      QUESTION_CODES.careAllowancePerson.contactType
    );
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: CareAllowancePersonSaveDataRequest = this.getRequestForSaveData(event);
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.showConfirmDialogAndSave(saveDataRequest);
      }
    }
    else {
      this.showConfirmDialogAndSave(saveDataRequest);
    }
  }

  cancel($event: any) {
    this.exit();
  }

  dialogButton_saveSuccessful_Clicked(event: any) {
    this.exit(true);
  }

  private exit(ignoreUnsavedChanges = false) {
    if (ignoreUnsavedChanges || this.isEditing) {
      this.navigate(['/', ROUTE_CONSTANTS.person.prefixDetail, this.id], ignoreUnsavedChanges);
    }
    else {
      const navExtras = this.getNavigationExtras();
      this.navigate([ROUTE_CONSTANTS.person.list], ignoreUnsavedChanges, navExtras);
    }
  }

  private showConfirmDialogAndSave(saveDataRequest: CareAllowancePersonSaveDataRequest) {
    if (this.isEditing) {
      this.activeDialog = this.isCareAllowanceCarer() || this.isConcessionsApplicant()
        ? POP_UP_CODES.careAllowancePerson.confirmCarerOrConcessionEdit
        : (this.isVptasClient() ? POP_UP_CODES.careAllowancePerson.confirmVptasClientEdit : POP_UP_CODES.careAllowancePerson.confirmClientEdit);
      this.dialogService.showConfirm(this.activeDialog)
        .pipe(take(1))
        .subscribe(result => {
          if (result === DialogResult.ACCEPTED) {
            this.saveData(saveDataRequest);
          }
        });
    }
    else {
      const selectedContactTypeText = this.optionSetService.getOptionText(OPTION_SETS.personRole.code.toLowerCase(), this.selectedContactType)
      this.activeDialog = this.isCareAllowanceCarer()
        ? POP_UP_CODES.careAllowancePerson.confirmCarerSave
        : (this.isVptasClient() ? POP_UP_CODES.careAllowancePerson.confirmVptasClientSave : POP_UP_CODES.careAllowancePerson.confirmClientSave);
      this.dialogService.showConfirm(this.activeDialog, { contactType: selectedContactTypeText })
        .pipe(take(1))
        .subscribe(result => {
          if (result === DialogResult.ACCEPTED) {
            this.saveData(saveDataRequest);
          }
        });
    }
  }

  private saveData(request: CareAllowancePersonSaveDataRequest) {
    this.spinnerService.showSpinner();
    this.registerSubscription(
      this.dataService.saveData(API_ENDPOINTS.careAllowancePerson.save, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.id = data.id;
            this.activeDialog = POP_UP_CODES.common.saveSuccessful;
            this.dialogService.showDialog(this.activeDialog);
          }
        })
    );
  }

  private getRequestForSaveData(event: SaveFormEvent): CareAllowancePersonSaveDataRequest {
    let model = JSON.parse(event.model);
    // Update the model with the boolean values as questions (isEditing, showContactType, showMultiContactType) to be used during server validation of condition functions.
    this.responseParserService.replaceQuestionModel(model,
      NAV_TAB_NUMBERS.careAllowancePerson.personDetails,
      PAGE_NUMBERS.careAllowancePerson.personDetails,
      null,
      SECTION_CODES.careAllowancePerson.profile,
      null,
      QUESTION_CODES.careAllowancePerson.isEditing,
      this.isEditing
    );

    this.responseParserService.replaceQuestionModel(model,
      NAV_TAB_NUMBERS.careAllowancePerson.personDetails,
      PAGE_NUMBERS.careAllowancePerson.personDetails,
      null,
      SECTION_CODES.careAllowancePerson.profile,
      null,
      QUESTION_CODES.careAllowancePerson.showContactType,
      this.showContactType
    );

    this.responseParserService.replaceQuestionModel(model,
      NAV_TAB_NUMBERS.careAllowancePerson.personDetails,
      PAGE_NUMBERS.careAllowancePerson.personDetails,
      null,
      SECTION_CODES.careAllowancePerson.profile,
      null,
      QUESTION_CODES.careAllowancePerson.showMultiContactType,
      this.showMultiContactType
    );
    return {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: JSON.stringify(model),
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit,
      isConcessionApplicantUpdated: (this.isConcessionContact || this.isVptasClient) && this.isEditing && this.showContactType && this.showMultiContactType
    }
  }

  private showPostalAddress() {
    return this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.postalAddressSameAsPrimaryAddress === OPTION_SETS.postalAddressSameOrDifferent.options.addNewPostalAddress;
  }

  private showCommonFields() {
    return this.isCareAllowanceCarer() || this.isCareAllowanceClient() || this.isConcessionContact || this.isVptasClient();
  }

  private isVptasClient() {
    return this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.contactType === OPTION_SETS.personRole.options.vptasApplicant;
  }
  private isCareAllowanceClient() {
    return this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.contactType === OPTION_SETS.personRole.options.careAllowanceClient;
  }

  private isCareAllowanceCarer() {
    return this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.contactType === OPTION_SETS.personRole.options.careAllowanceCarer
      ||
      (this.isMultiContactTypeReadOnly() && this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.multiContactType.includes(OPTION_SETS.personRole.options.careAllowanceCarer));
  }

  private isConcessionsApplicant() {
    return this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.contactType === OPTION_SETS.personRole.options.concessionApplicant
      ||
      (this.isMultiContactTypeReadOnly() && this.baseForm?.model?.form?.tabs?.tab2?.page1?.profile?.multiContactType.includes(OPTION_SETS.personRole.options.concessionApplicant));
  }
private isConcessionOrVptasApplicant() {
    return  this.isVptasClient();
  }

  private isMultiContactTypeReadOnly() {
    return this.isEditing && !this.showContactType && this.showMultiContactType;
  }

  private getNavigationExtras(): NavigationExtras {
    return {
      state: {
        placementFilterRequest: history.state.placementFilterRequest,
        personFilterRequest: history.state.personFilterRequest
      }
    };
  }
}
